import {
  STUDENTS_GET,
  ROMBEL_PORTALUSERS_GET,
  ROMBEL_ADD,
  ROMBEL_EDIT,
  STUDENT_ROMBEL_GET,
  ROMBEL_DELETE,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
  },
  items: [],
  gurus: [],
  jenjangs: [],
  kelass: [],
  years: [],
  sems: [],
  rombels: [],
};

const studentsGet = (state, payload) => {
  const rawStudents = payload.students;
  const rombels = rawStudents.rombels;
  const search = rawStudents.search;
  const jenjangs = rawStudents.jenjangs;
  const kelass = rawStudents.kelass;
  const years = rawStudents.years;
  const sems = rawStudents.sems;
  let items = [];
  let total = 0;
  rombels?.[0] &&
    rombels.forEach((r) => {
      let rawStudents = r?.students && JSON.parse(r.students);
      let students = [];
      rawStudents?.[0] &&
        rawStudents.forEach((s) => {
          students = [
            ...students,
            {
              ...s,
              jenjang: r.jenjang,
              kelas: r.kelas,
              year: r.year,
              sem: r.sem,
            },
          ];
        });
      items = [...items, ...students];
      total = total + (rawStudents?.length ?? 0);
    });
    
  return {
    ...state,
    items,
    total,
    rombels,
    search,
    jenjangs,
    kelass,
    years,
    sems,
  };
};

const rombelAdd = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) + 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.rombel.id + ''),
      payload.rombel,
    ],
    search: { ...state.search },
  };
};

const rombelEdit = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.rombel.id + ''),
      payload.rombel,
    ],
  };
};

const studentRombelGet = (state, payload) => {
  let rawRombel = payload.rombel;
  let rombel = rawRombel.rombel;
  let gurus = rawRombel.gurus;
  let jenjangs = rawRombel.jenjangs;
  let kelass = rawRombel.kelass;
  let years = rawRombel.years;
  let sems = rawRombel.sems;
  return {
    ...state,
    items: [...state.items.filter((i) => i.id + '' !== rombel.id + ''), rombel],
    gurus,
    jenjangs,
    kelass,
    years,
    sems,
  };
};

const rombelPortalusersGet = (state, payload) => {
  let rombels = payload.rombel.rombels;
  let portalusers = payload.rombel.portalusers;
  return {
    ...state,
    rombels,
    portalusers,
  };
};

const rombelDelete = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) - 1,
    items: [...state.items.filter((i) => i.id + '' !== payload.rombel.id + '')],
  };
};

export default createReducer(initialState, {
  [STUDENTS_GET]: studentsGet,
  [ROMBEL_PORTALUSERS_GET]: rombelPortalusersGet,
  [ROMBEL_ADD]: rombelAdd,
  [ROMBEL_EDIT]: rombelEdit,
  [STUDENT_ROMBEL_GET]: studentRombelGet,
  [ROMBEL_DELETE]: rombelDelete,
});
